import React, { useEffect, useState } from 'react';

import { IonContent } from '@ionic/react';
import { IonList, IonItem, IonHeader, IonTitle, IonToolbar, IonButtons, IonBackButton } from '@ionic/react';
import OptionService from '../services/option';

const ShiftsPage = (props) => {
  const [options, setOptions] = useState(null);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await OptionService.allClean();
        const optionsData = response.data.data;
        setOptions(optionsData);
      } catch (error) {
        console.error('Errore durante il caricamento delle opzioni:', error);
      }
    };
    fetchOptions();
  }, []);

  return (
    <>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" />
          </IonButtons>
          <IonTitle>Turni</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent class="ion-padding-top" fullscreen>
        {options?.turni ? (
          <iframe
            src={`${options?.turni}`}
            style={{ width: '100%', height: '100vh', border: 'none' }}
            title="PDF Viewer"
          />
        ) : (
          <IonList>
            <IonItem>Al momento non ci sono turni disponibili.</IonItem>
          </IonList>
        )}
      </IonContent>
    </>
  );
};

export default ShiftsPage;
